import { Injectable, EventEmitter } from '@angular/core';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { Globals } from '../globals';
import { GeneralService } from './general.service';
import { PermisoService } from './permiso.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class LandingService {

  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService
  ) { }
  public deleteI: EventEmitter<any> = new EventEmitter();
  // landings 
  crearLanding(model): Observable<any> {
    return this.permisoService.getPermisoAction('CREAR-LANDING')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify(model)
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  editarLanding(model): Observable<any> {
    return this.permisoService.getPermisoAction('EDITAR-LANDING')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify(model)
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }

  getLanding(model): Observable<any> {
    return this.permisoService.getPermisoAction('GET-LANDING')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }

  getCamposDisponibles(model) {
    return this.permisoService.getPermisoAction('GET-CAMPOS-LANDING')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  // campanias de venta
  crearCampaniaVenta(model): Observable<any> {
    return this.permisoService.getPermisoAction('CREAR-CAMPANIA-VENTA')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  getCampanias(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: null,
      order: null
    },
    filtros: any = {
      generico: ''
    }): Observable<any> {
    return this.permisoService.getPermisoAction('GET-CAMPANIA')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          )
          .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
            (respuesta: Response) => respuesta.json()

          );
      });
  }
  editarCampania(model): Observable<any> {
    return this.permisoService.getPermisoAction('EDITAR-CAMPANIA')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  getPosiciones(model): Observable<any> {
    return this.permisoService.getPermisoAction('GET-POSICIONES')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  eliminarImagen(model): Observable<any> {
    return this.permisoService.getPermisoAction('ELIMINAR-IMAGEN-LANDING')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
}
